interface IColors {
  [key: string]: string;
}

export const Colors: IColors = {
  primary: '#007bff',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  info: '#17a2b8',
  cinza: '#63829c',
  verde: '#006F7F',
  verdeClaro: '#188F8F',
};

export const Sizes = [8, 16, 24, 32];
